import React, { FC, useState } from 'react';
import { Box, debounce, Stack } from '@mui/material';
import { UserRole } from '../../types/user.types';
import { UsersTable } from './UsersTable';
import { metaTitle } from '../../util/tabTitle';
import { useIsUserRole } from '../../util/useIsUserRole';
import { AddUserModal } from '../admin/users/components/AddUserModal';
import { DEBOUNCE_TIME } from '../../configs';
import Breadcrumbs from '../../components/Breadcrumb';
import {
  ManagementPageHeader,
  ManagementSearch,
  ManagementToolbar,
  RefreshAction,
} from '../../components/ManagementPageLayout';

const UsersPage: FC = () => {
  metaTitle('Users');
  const [openUserModal, setOpenUserModal] = useState(false);
  const [refreshUserTable, setRefreshUserTable] = useState(false);
  const [search, setSearch] = useState('');
  const [searchText, setSearchText] = useState('');

  const disableAddUser = useIsUserRole([
    UserRole.user,
    UserRole.dataEditor,
    UserRole.layoutEditor,
  ]);

  return (
    <Box sx={{ width: '100%', maxWidth: 1360, mx: 'auto' }}>
      <Breadcrumbs items={[{ label: 'Users', to: '/users' }]} />
      <ManagementPageHeader
        title="Users & roles"
        subtitle="Manage user access, roles, and account security."
        actionLabel="Add user"
        onAction={() => setOpenUserModal(true)}
        actionDisabled={disableAddUser}
      />
      <ManagementToolbar>
        <ManagementSearch
          placeholder="Search users"
          value={searchText}
          onChange={(event) => {
            setSearchText(event.target.value);
            debounce(() => setSearch(event.target.value), DEBOUNCE_TIME)();
          }}
        />
        <Stack direction="row" justifyContent="flex-end">
          <RefreshAction
            onClick={() => setRefreshUserTable(!refreshUserTable)}
          />
        </Stack>
      </ManagementToolbar>

      <UsersTable search={search} refresh={refreshUserTable} />

      <AddUserModal
        onClose={() => setOpenUserModal(false)}
        open={openUserModal}
        onFinished={() => {
          setOpenUserModal(false);
          setRefreshUserTable(!refreshUserTable);
        }}
      />
    </Box>
  );
};

export default UsersPage;
